document.addEventListener("DOMContentLoaded", function() {
    // Vérifier qu'on est bien sur une page produit
    if (!document.body.classList.contains('template-product') && 
        !document.querySelector('.product-form') && 
        !document.querySelector('.product__info-container')) {
        return; // Sortir si ce n'est pas une page produit
    }
    
    // Sélecteurs sécurisés qui ciblent spécifiquement la section produit
    var productSection = document.querySelector('.product, [class*="product--"], .product-single');
    if (!productSection) return;
    
    var mediaGallery = productSection.querySelector('[id^="MediaGallery-template--"]');
    var priceElement = productSection.querySelector('[id^="price-template--"]');
    
    // Alternative avec des classes CSS (plus robuste)
    // var mediaGallery = document.querySelector('.product__media-wrapper media-gallery');
    // var priceElement = document.querySelector('.price[role="status"]');
    
    if (!mediaGallery || !priceElement) {
        console.warn('Éléments MediaGallery ou Price non trouvés');
        return;
    }
    
    var originalParent = mediaGallery.parentElement;
    var originalNextSibling = mediaGallery.nextElementSibling;
    
    function repositionElements() {
        if (window.innerWidth <= 767) {
            // Mode mobile : déplacer la galerie après le prix
            if (priceElement.parentNode && mediaGallery.parentNode !== priceElement.parentNode) {
                priceElement.parentNode.insertBefore(mediaGallery, priceElement.nextElementSibling);
            }
        } else {
            // Mode desktop : remettre la galerie à sa position originale
            if (originalParent && mediaGallery.parentNode !== originalParent) {
                if (originalNextSibling) {
                    originalParent.insertBefore(mediaGallery, originalNextSibling);
                } else {
                    originalParent.appendChild(mediaGallery);
                }
            }
        }
    }
    
    // Exécuter au chargement
    repositionElements();
    
    // Écouter les redimensionnements avec un délai pour optimiser les performances
    let resizeTimeout;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(repositionElements, 100);
    });
});